import { render, staticRenderFns } from "./AddExternalB2GInvoice.vue?vue&type=template&id=12ebd1e8&scoped=true"
import script from "./AddExternalB2GInvoice.vue?vue&type=script&lang=js"
export * from "./AddExternalB2GInvoice.vue?vue&type=script&lang=js"
import style0 from "./AddExternalB2GInvoice.vue?vue&type=style&index=0&id=12ebd1e8&prod&scoped=true&lang=css"
import style1 from "./AddExternalB2GInvoice.vue?vue&type=style&index=1&id=12ebd1e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ebd1e8",
  null
  
)

export default component.exports